/**
 * Número de soporte por WhatsApp (+34 711 50 39 75, WhatsApp Business API,
 * definitivo desde el 28 sep 2026), solo dígitos para el enlace. Vivía en
 * web/components/SupportButton.tsx; pasó aquí (18 oct 2026) para que lo use
 * también el correo de novedades de la API. SupportButton lo importa de aquí.
 */
export const WHATSAPP_SOPORTE = '34711503975';
export const WHATSAPP_MENSAJE_SOPORTE = 'Hola, necesito ayuda con Alexia Rest';

export const whatsappSoporte = (mensaje: string = WHATSAPP_MENSAJE_SOPORTE): string =>
  `https://wa.me/${WHATSAPP_SOPORTE}?text=${encodeURIComponent(mensaje)}`;
